/* global fbq, gtag, ym */

export function sendForm() {
	fbq('track', 'Lead');
	gtag('event', 'Lead');
	ym(85430728, 'reachGoal', 'Lead');
}

function scroll() {
	let once = false;

	window.addEventListener('scroll', () => {
		if (!once && window.scrollY > document.body.clientHeight * 0.7) {
			gtag('event', 'scroll70');
			ym(85430728, 'reachGoal', 'scroll70');

			once = true;
		}
	});
}

export function init() {
	scroll();

	$('.js-analyitcs-login').on('click', () => {
		gtag('event', 'clicklogin');
		ym(85430728, 'reachGoal', 'clicklogin');
	});

	$('.js-analyitcs-connect').on('click', () => {
		gtag('event', 'clickconnect');
		ym(85430728, 'reachGoal', 'clickconnect');
	});
}
